export default __webpack_public_path__ + "static/media/U_Urso.4a9bcc6b.svg";